(function () {
  if (window.__ivypressCampaignCashInit) return;
  window.__ivypressCampaignCashInit = true;

  var API_HOST = 'https://api.ivypressdesigns.com';

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  async function fetchCart() {
    var res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart');
    return res.json();
  }

  function campaignSlug(cart) {
    var attrs = (cart && cart.attributes) || {};
    return attrs.ivypress_campaign || attrs.campaign_slug || '';
  }

  function campaignTitle(cart) {
    var attrs = (cart && cart.attributes) || {};
    return attrs.ivypress_campaign_title || '';
  }

  function organizerName(cart) {
    var attrs = (cart && cart.attributes) || {};
    var name = (attrs.ivypress_organizer_name || '').trim();
    return name || 'the organizer';
  }

  function fulfillmentType(cart) {
    var attrs = (cart && cart.attributes) || {};
    return String(attrs.ivypress_fulfillment || '').toUpperCase();
  }

  function isBulkFulfillment(cart) {
    return fulfillmentType(cart) === 'BULK';
  }

  function syncCtas(cart) {
    var slug = campaignSlug(cart);
    var show = !!(slug && cart && cart.item_count > 0);
    $all('[data-campaign-cash-cta]').forEach(function (el) {
      if (show) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    var org = organizerName(cart);
    $all('[data-campaign-cash-hint]').forEach(function (el) {
      el.textContent = show
        ? ('Fundraiser' + (campaignTitle(cart) ? ': ' + campaignTitle(cart) : '') + ' — pay ' + org + ' in cash instead of checking out online.')
        : '';
    });
    $all('[data-campaign-cash-open]').forEach(function (el) {
      if (show) el.textContent = 'Pay cash to ' + org;
    });
    var cashTitle = document.querySelector('#CampaignCashModal h3');
    if (cashTitle && show) cashTitle.textContent = 'Pay cash to ' + org;
    var cashInfo = document.querySelector('#CampaignCashModal .campaign-storefront__modal-info');
    if (cashInfo && show) {
      cashInfo.textContent = 'Place this cart as a cash order for ' + org + ' (no online payment). You\u2019ll pay them directly.';
    }
    var onlineInfo = document.querySelector('#CampaignOnlineModal .campaign-storefront__modal-info');
    if (onlineInfo && show) {
      onlineInfo.textContent = 'This fundraiser ships in bulk to ' + org + ' — no shipping address or delivery options at checkout. Continue to secure online payment.';
    }
    var count = cart ? cart.item_count : 0;
    $all('[data-campaign-cash-count]').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  async function refresh() {
    try {
      var cart = await fetchCart();
      syncCtas(cart);
      return cart;
    } catch (e) {
      return null;
    }
  }

  function openModal() {
    var modal = $('#CampaignCashModal');
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var modal = $('#CampaignCashModal');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-campaign-cash-open]')) {
      e.preventDefault();
      openModal();
    }
    if (e.target.closest('[data-campaign-cash-close]')) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('submit', async function (e) {
    var form = e.target;
    if (!form || form.id !== 'CampaignCashForm') return;
    e.preventDefault();

    var status = $('[data-campaign-cash-status]');
    var submitBtn = form.querySelector('[type="submit"]');
    if (status) {
      status.hidden = true;
      status.textContent = '';
    }
    if (submitBtn) submitBtn.disabled = true;

    try {
      var cart = await fetchCart();
      var slug = campaignSlug(cart);
      if (!slug) throw new Error('This cart is not linked to a fundraiser. Open the campaign page first, then add items.');
      if (!cart.items || !cart.items.length) throw new Error('Your cart is empty.');

      var cart_items = (cart.items || []).map(function (item) {
        var price = item.final_price != null ? item.final_price : item.price;
        if (typeof price === 'number') price = price / 100;
        return {
          variant_id: item.variant_id || item.id || null,
          product_id: item.product_id,
          title: item.product_title || item.title || null,
          quantity: item.quantity,
          price: price,
          properties: item.properties || {},
        };
      });

      var payload = {
        cart_items: cart_items,
        buyer_name: (form.buyer_name && form.buyer_name.value || '').trim(),
        buyer_email: (form.buyer_email && form.buyer_email.value || '').trim(),
        buyer_phone: (form.buyer_phone && form.buyer_phone.value || '').trim() || null,
        notes: (form.notes && form.notes.value || '').trim() || null,
      };

      var res = await fetch(API_HOST + '/api/storefront/campaigns/' + encodeURIComponent(slug) + '/orders/from-cart', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCookie('csrf_token') || '',
        },
        credentials: 'include',
        body: JSON.stringify(payload),
      });

      var data = {};
      try { data = await res.json(); } catch (_) {}
      if (!res.ok) {
        var detail = data && (data.detail || data.message);
        if (Array.isArray(detail)) {
          detail = detail.map(function (x) {
            if (!x) return '';
            if (typeof x === 'string') return x;
            var loc = Array.isArray(x.loc) ? x.loc.join('.') : '';
            return (loc ? loc + ': ' : '') + (x.msg || JSON.stringify(x));
          }).filter(Boolean).join('; ');
        } else if (detail && typeof detail === 'object') {
          detail = JSON.stringify(detail);
        }
        throw new Error(detail || ('Order failed (' + res.status + ')'));
      }

      await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          attributes: {
            ivypress_campaign: '',
            ivypress_campaign_title: '',
            ivypress_fulfillment: '',
            ivypress_organizer_name: '',
          },
        }),
      });

      if (status) {
        status.hidden = false;
        status.style.color = 'green';
        status.textContent = 'Order placed! Give this code to ' + organizerName(cart) + ': ' + (data.order_number || data.id || 'submitted');
      }

      setTimeout(function () {
        closeModal();
        window.location.href = '/cart';
      }, 1800);
    } catch (err) {
      if (status) {
        status.hidden = false;
        status.style.color = 'crimson';
        status.textContent = (err && err.message) || 'Could not place cash order.';
      }
      if (submitBtn) submitBtn.disabled = false;
    }
  });

  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
  // Dawn / theme cart events
  document.addEventListener('cart:change', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  // Periodic light refresh while drawer open / after AJAX adds
  setInterval(refresh, 4000);

  function openOnlineModal() {
    var modal = $('#CampaignOnlineModal');
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeOnlineModal() {
    var modal = $('#CampaignOnlineModal');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-campaign-online-close]')) {
      e.preventDefault();
      closeOnlineModal();
      return;
    }

    // Bulk fundraiser: intercept native Checkout so Shopify does not show delivery options.
    var checkoutBtn = e.target.closest('[name="checkout"], #checkout, .cart__checkout-button');
    if (!checkoutBtn) return;
    // Allow cash modal buttons through
    if (checkoutBtn.closest('[data-campaign-cash-cta], [data-campaign-cash-open]')) return;

    // Only intercept when we already know this is a campaign cart; async check next.
    e.preventDefault();
    e.stopPropagation();
    (async function () {
      try {
        var cart = await fetchCart();
        var slug = campaignSlug(cart);
        if (!slug) {
          // Not a campaign cart — proceed with native checkout
          var form = checkoutBtn.closest('form');
          if (form) {
            // Create a temp input so native submit works without our handler looping
            checkoutBtn.removeAttribute('name');
            var hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'checkout';
            hidden.value = '';
            form.appendChild(hidden);
            form.submit();
          } else {
            window.location.href = '/checkout';
          }
          return;
        }
        var fulfillment = fulfillmentType(cart);
        if (!fulfillment) {
          // Resolve from API once
          try {
            var meta = await fetch(API_HOST + '/api/storefront/campaigns/' + encodeURIComponent(slug), { credentials: 'omit' });
            if (meta.ok) {
              var data = await meta.json();
              fulfillment = String(data.fulfillment_type || '').toUpperCase();
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({
                  attributes: {
                    ivypress_campaign: slug,
                    ivypress_campaign_title: campaignTitle(cart) || (data.name || ''),
                    ivypress_fulfillment: fulfillment,
                    ivypress_organizer_name: (data.organizer_name || '').toString().trim()
                  }
                })
              });
            }
          } catch (err) {}
        }
        if (fulfillment === 'BULK') {
          openOnlineModal();
          return;
        }
        // Individual fulfillment: native Shopify checkout (shipping allowed)
        window.location.href = '/checkout';
      } catch (err) {
        window.location.href = '/checkout';
      }
    })();
  }, true);

  document.addEventListener('submit', async function (e) {
    var form = e.target;
    if (!form || form.id !== 'CampaignOnlineForm') return;
    e.preventDefault();

    var status = $('[data-campaign-online-status]');
    var submitBtn = form.querySelector('[type="submit"]');
    if (status) {
      status.hidden = true;
      status.textContent = '';
    }
    if (submitBtn) submitBtn.disabled = true;

    try {
      var cart = await fetchCart();
      var slug = campaignSlug(cart);
      if (!slug) throw new Error('Missing campaign');
      var items = (cart.items || []).map(function (line) {
        return {
          variant_id: line.variant_id,
          product_id: line.product_id,
          title: line.product_title || line.title,
          quantity: line.quantity,
          price: typeof line.final_line_price === 'number' ? line.final_line_price / 100 : undefined,
          properties: line.properties || {}
        };
      });
      if (!items.length) throw new Error('Cart is empty');

      var payload = {
        buyer_name: (form.buyer_name && form.buyer_name.value || '').trim(),
        buyer_email: (form.buyer_email && form.buyer_email.value || '').trim(),
        buyer_phone: (form.buyer_phone && form.buyer_phone.value || '').trim() || null,
        cart_items: items
      };

      var res = await fetch(API_HOST + '/api/storefront/campaigns/' + encodeURIComponent(slug) + '/checkout-from-cart', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': getCookie('csrftoken') || ''
        },
        credentials: 'omit',
        body: JSON.stringify(payload)
      });
      var body = await res.json().catch(function () { return {}; });
      if (!res.ok) {
        var detail = body.detail || body.message || ('Checkout failed (' + res.status + ')');
        if (Array.isArray(detail)) detail = detail.map(function (d) { return d.msg || JSON.stringify(d); }).join('; ');
        throw new Error(detail);
      }
      if (!body.checkout_url) throw new Error('No checkout URL returned');

      // Clear campaign cart before leaving for payment
      try {
        await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
      } catch (clearErr) {}

      window.location.href = body.checkout_url;
    } catch (err) {
      if (status) {
        status.hidden = false;
        status.style.color = '#b00020';
        status.textContent = (err && err.message) || 'Checkout failed';
      }
      if (submitBtn) submitBtn.disabled = false;
    }
  });

})();
